import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogHeightModes,
    DialogTitle,
    DialogTrigger,
    DialogVerticalPositions,
} from "@app/componentLibrary/ui/dialog";
import { ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";

import { SearchConfigurator } from "../components/SearchConfigurator";

export interface ISearchConfiguratorDialogProps {
    triggerButton: ReactElement | ReactElement[];
}

export const SearchConfiguratorDialog = ({ triggerButton }: ISearchConfiguratorDialogProps) => {
    const { t } = useTranslation(["availability", "common"]);
    const [open, setOpen] = useState(false);

    return (
        <Dialog
            open={open}
            onOpenChange={(isOpen) => {
                setOpen(isOpen);
            }}
        >
            <DialogTrigger asChild>{triggerButton}</DialogTrigger>
            <DialogContent verticalPosition={DialogVerticalPositions.Bottom} heightMode={DialogHeightModes.Full}>
                <DialogHeader>
                    <DialogTitle>{t("search.changeSelection")}</DialogTitle>
                </DialogHeader>
                <SearchConfigurator onSearchClick={() => setOpen(false)} showChangePropertyButton={false} />
            </DialogContent>
        </Dialog>
    );
};
